import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { graphql, compose } from 'react-apollo';
import { Form, Input, DatePicker, Button, message } from 'antd';
import validationRegex from '../utils/validationRegex';

import MUTATION from '../graphql/mutations/editBasicCustomerDetailsMutation.graphql';

const FormItem = Form.Item;

class BasicOrgDetailsForm extends Component {
  state = {
    submittingForm: false,
  };

  handleSubmit = (event) => {
    this.setState({
      submittingForm: true,
    });
    event.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this.props.mutate({
          variables: { id: this.props.id, ...values },
        })
          .then(() => {
            this.setState({
              submittingForm: false,
            });
            this.props.form.resetFields();
            message.success('Success!');
          })
          .catch((mutateErr) => {
            console.log(mutateErr);
            this.setState({
              submittingForm: false,
            });
            message.error(mutateErr.message);
          });
      } else {
        console.log(err);
        this.setState({
          submittingForm: false,
        });
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;

    return (
      <Form onSubmit={this.handleSubmit} layout="vertical" className="bank-form">
        <FormItem
          hasFeedback
          label="PAN no."
        >
          {
            getFieldDecorator(
              'pan_no',
              {
                rules: [
                  {
                    required: true,
                    message: 'PAN no. is required!',
                  },
                  {
                    pattern: validationRegex.pan_no,
                    message: 'Incorrect PAN!',
                  },
                ],
              },
            )(<Input />)
          }
        </FormItem>
        <FormItem
          hasFeedback
          label="Date of formation/birth"
        >
          {
            getFieldDecorator(
              'formation_date',
              {
                rules: [
                  {
                    required: true,
                    message: 'Date is required!',
                  },
                ],
              },
            )(<DatePicker />)
          }
        </FormItem>
        <FormItem className="form-item-block">
          <Button type="primary" size="small" htmlType="submit" loading={this.state.submittingForm}>Submit</Button>
        </FormItem>
      </Form>
    );
  }
}

BasicOrgDetailsForm.propTypes = {
  id: PropTypes.number.isRequired,
  mutate: PropTypes.func.isRequired,
  form: PropTypes.shape({
    getFieldDecorator: PropTypes.func,
    validateFieldsAndScroll: PropTypes.func,
    resetFields: PropTypes.func,
  }).isRequired,
};

export default compose(
  // graphql(QUERIES),
  graphql(MUTATION),
  Form.create(),
)(BasicOrgDetailsForm);



// WEBPACK FOOTER //
// ./src/forms/BasicOrgDetailsForm.jsx